export const cardLayoutByVariant = {
  desktop: {
    gap: 24,
    px: 40,
    py: 40,
  },
  laptop: {
    gap: 24,
    px: 24,
    py: 40,
  },
  mobile: {
    gap: 8,
    px: 24,
    py: 24,
  },
  tablet: {
    gap: 8,
    px: 24,
    py: 24,
  },
};
